import { styled } from '@mui/material'
import { Box } from 'presentation/components/atoms'

export const ValueContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  '& + &': { marginTop: '24px' },
}))
